import { Group, Paper, Text, ThemeIcon } from "@mantine/core";
import type { IconProps } from "@tabler/icons-react";
import type { ComponentType, ReactNode } from "react";
import { axioTokens } from "../../theme";

interface StatCardProps {
  label: string;
  value: string | number;
  icon: ComponentType<IconProps>;
  color?: string;
  trend?: ReactNode;
  "data-testid"?: string;
}

export function StatCard({
  label,
  value,
  icon: Icon,
  color = "violet",
  trend,
  "data-testid": testId,
}: StatCardProps) {
  return (
    <Paper
      withBorder

      p="lg"
      style={{ borderColor: axioTokens.border, boxShadow: "none" }}
      data-testid={testId}
    >
      <Group justify="space-between" align="flex-start" wrap="nowrap">
        <div>
          <Text c="dimmed" fw="var(--axio-font-weight-semibold)" size="xs">
            {label}
          </Text>
          <Text
            fw="var(--axio-font-weight-bold)"
            size="xl"
            mt="var(--axio-unit-4)"
            className="tabular"
            style={{ fontFamily: axioTokens.fontHead, letterSpacing: "var(--axio-letter-spacing-tight)" }}
          >
            {value}
          </Text>
          {trend}
        </div>
        <ThemeIcon
          color={color}
          variant="light"
          size="var(--axio-unit-40)"

        >
          <Icon size="var(--axio-unit-20)" stroke="var(--axio-stroke-width-subtle)" />
        </ThemeIcon>
      </Group>
    </Paper>
  );
}
